import { IconStyled, IconStylesProps } from './IconStyles';

export const Clock = ({ size = 'base', className = '' }: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    viewBox="0 0 19 19"
    fill="none"
    width="19"
    height="19"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5 0C4.25202 0 0 4.25202 0 9.5C0 14.748 4.25202 19 9.5 19C14.748 19 19 14.748 19 9.5C19 4.25202 14.748 0 9.5 0ZM11.6873 13.4111L8.30867 10.9556C8.18992 10.8675 8.12097 10.7296 8.12097 10.5841V4.1371C8.12097 3.88427 8.32782 3.67742 8.58065 3.67742H10.4194C10.6722 3.67742 10.879 3.88427 10.879 4.1371V9.41189L13.3115 11.1817C13.5183 11.331 13.5605 11.6183 13.4111 11.8252L12.3308 13.3115C12.1815 13.5145 11.8942 13.5605 11.6873 13.4111Z" fill="#0076C0"/>
  </IconStyled>
);
